import { motion } from 'framer-motion';
import { Award, Users, MapPin, Handshake } from 'lucide-react';

// Placeholder for about image

const features = [
  {
    icon: Award,
    title: 'Erfahrung',
    description: 'Jahrelange Erfahrung im Autoankauf',
  },
  {
    icon: Handshake,
    title: 'Fairer Ankauf',
    description: 'Transparente und faire Bewertungen',
  },
  {
    icon: Users,
    title: 'Persönliche Beratung',
    description: 'Individuelle Betreuung für jeden Kunden',
  },
  {
    icon: MapPin,
    title: 'Deutschland- & Europaweit',
    description: 'Wir kommen zu Ihnen – überall',
  },
];

export const About = () => {
  return (
    <section id="ueber-uns" data-testid="about-section" className="py-20 md:py-28 bg-tiktok-surface">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Placeholder Side */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-tiktok-surface to-tiktok-elevated border border-white/10">
              {/* Placeholder Content */}
              <div className="w-full h-[400px] md:h-[500px] flex flex-col items-center justify-center p-8">
                {/* Decorative Icon */}
                <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-tiktok-cyan/20 to-tiktok-pink/20 flex items-center justify-center mb-6 border border-white/10">
                  <svg className="w-12 h-12 text-tiktok-cyan" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <p className="text-gray-500 text-center mb-2">Bild-Platzhalter</p>
                <p className="text-gray-600 text-sm text-center">Hier kommt Ihr Teambild oder Firmenlogo</p>
              </div>
              
              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-tiktok-black/90 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-tiktok-cyan to-tiktok-pink flex items-center justify-center">
                      <span className="text-white font-bold text-lg">24/7</span>
                    </div>
                    <div>
                      <p className="text-white font-semibold">Immer erreichbar</p>
                      <p className="text-sm text-gray-400">Rund um die Uhr für Sie da</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-tiktok-cyan/20 rounded-full blur-2xl" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-tiktok-pink/20 rounded-full blur-2xl" />
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-tiktok-pink mb-4 block">
              Über uns
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Warum{' '}
              <span className="text-tiktok-cyan">PKW Ankauf 24/7</span>?
            </h2>
            <p className="text-gray-300 text-lg mb-8">
              Wir sind Ihr vertrauenswürdiger Partner für den schnellen und fairen Autoankauf – deutschlandweit und europaweit. Mit unserer langjährigen Erfahrung bieten wir Ihnen eine transparente Abwicklung und faire Preise – egal in welchem Zustand sich Ihr Fahrzeug befindet.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="flex items-start gap-4 p-4 bg-tiktok-black/50 rounded-xl border border-white/5"
                >
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-tiktok-cyan/20 to-tiktok-pink/20 flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-5 h-5 text-tiktok-cyan" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-400">{feature.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
